import React, { useState, useEffect } from 'react'
import { FaPencilAlt, FaShoppingBasket } from 'react-icons/fa';
import Spinner from 'react-bootstrap/Spinner';
import { FiSearch } from "react-icons/fi";
import { Alerts, GetOrders, GetProducts, GetUser, GetSettings } from "../../../helpers";
import { FiMinus, FiPlus } from 'react-icons/fi';
import { MdOutlineClose } from "react-icons/md";
import { Card } from 'react-bootstrap';
import ThemeModal from '../../../components/cmp/ThemeModal';
import AddAddressCreateOrder from '../../../components/order/AddAddressCreateOrder';
import { Link } from 'react-router-dom';
import AddNewUser from './AddNewUser';
import parse from 'html-react-parser'
const CreateOrder = () => {
    const [query, setQuery] = useState("");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0);  // default: 0
    const [delivery, setDelivery] = useState(0);  // default: 0
    const [tax, setTax] = useState(0);
    const [total, setTotal] = useState(0);
    const [orderNote, setOrderNote] = useState('');
    const [isShowNote, setShowNote] = useState(false);
    const [orderNoteValue, setOrderNoteValue] = useState('');
    const [cQuery, setcQuery] = useState("");
    const [customers, setCustomers] = useState([]);
    const [customer, setCustomer] = useState(null);
    const [userLoading, setUserLoading] = useState(false);
    const [customerAddresses, setCustomerAddresses] = useState([]);
    const [isAddressShow, setAddressShow] = useState(false);
    const [addNewAddress, setAddNewAddress] = useState(false);
    const [addressType, setAddressType] = useState("");
    const [shippingAddress, setShippingAddress] = useState(null);
    const [billingAddress, setBillingAddress] = useState(null);
    const [finalLoading, setFinalLoading] = useState(false);
    const [paymentLink, setPaymentLink] = useState('');
    const [isShowSuccess, setShowSuccess] = useState(false);
    const [shipping_rates, setShippingRates] = useState([]);
    const [selectedShippingMethod, setSelectedShippingMethod] = useState(null);
    const [shipping_price, setShippingPrice] = useState(0.00);

   
    const handleOpenAddress = (addressType) => {
        setAddressShow(true);
        setAddressType(addressType)
    }

    const handleCloseAddress = () => {
        setAddressShow(false);
    }

    useEffect(() => {
        if (query.length < 2) {
            setProducts([]);
            return;
        }
        const fetchSuggestions = async () => {
            setLoading(true);
            try {
                const resp = await GetProducts.searchProducts(query)
                if (resp && resp.status) {
                    console.log(resp.results);
                    setProducts(resp.results);
                }
            } catch (error) {
                console.error("Error fetching suggestions:", error);
            }
            setLoading(false);
        };

        const delayDebounceFn = setTimeout(fetchSuggestions, 300); // Debounce API calls

        return () => clearTimeout(delayDebounceFn);
    }, [query]);

    const handleCustomer = async (user) => {
        setCustomer(user);
        setCustomerAddresses(user.addresses)
        setCustomers([]);
        setcQuery("");
        setShippingAddress(null);
        setBillingAddress(null);
    }


    useEffect(() => {
        if (cQuery.length < 2) {
            setCustomers([]);
            return;
        }
        const fetchSuggestions = async () => {
            setUserLoading(true);
            try {
                const resp = await GetUser.searchUserByEmail(cQuery);
                if (resp && resp.status) {
                    setCustomers(resp.users);
                    if (resp.users && resp.users.length === 1) {
                        const newUser = resp.users[0];
                        if (newUser.email === cQuery) {
                            handleCustomer(newUser);
                        }
                    }

                }
            } catch (error) {
                console.error("Error fetching suggestions:", error);
            }
            setUserLoading(false);
        };
        const delayDebounceFn = setTimeout(fetchSuggestions, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [cQuery]);


    useEffect(() => {
        const newSubtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
        const newTax = newSubtotal * 0.20; 
        const newTotal = newSubtotal - discount + shipping_price + newTax;

        setSubtotal(newSubtotal);
        setTax(newTax);
        setTotal(newTotal);
    }, [cartItems, discount, shipping_price]);

    const getShippingZonesData = async (reqData) => {
        const resp = await GetSettings.getShippingMethods(reqData);
        if (resp && resp.status) {
            if (resp.shipping_zones && resp.shipping_zones.shipping_zone_rates) {
                setShippingRates(resp.shipping_zones.shipping_zone_rates);
            }
        }
    }
    useEffect(() => {
        if (shippingAddress && billingAddress) {
            if (subtotal) {
                getShippingZonesData({ country_code: shippingAddress.country_code, reason_code: shippingAddress.reason_code, cart_price: subtotal });
            }
        }
    }, [shippingAddress, billingAddress, subtotal]);


    const getProduct = async (product) => {
        setLoading(true);
        let produt_id = product.product_id;
        let product_type = product.is_variation ? 'variation' : ''
        const resp = await GetProducts.getProductById(produt_id, product_type);
        let productData = resp.product;
        if (resp && resp.status) {
            if (product_type === 'variation') {
                setSelectedProducts(prev => [...prev, productData]);
                setCartItems(prev => [
                    ...prev,
                    {
                        id: productData.id,
                        product_id: productData.product.id,
                        isVariation: true,
                        title: productData.variation_content.title,
                        image: productData.variation_main_image.path,
                        sku: productData.sku,
                        quantity: 1,
                        price: productData.sale_price
                    }
                ]);
            } else {
                setSelectedProducts(prev => [...prev, productData]);
                setCartItems(prev => [
                    ...prev,
                    {
                        id: productData.id,
                        product_id: productData.id,
                        isVariation: false,
                        title: productData.title,
                        image: productData.product_thumbnail.path,
                        sku: productData.sku,
                        quantity: 1,
                        price: productData.sale_price
                    }
                ]);
            }

            setLoading(false);
            setProducts([]);
            setQuery("");
        }
    }
    const removeSelected = (id) => {
        let remProducts = cartItems.filter(el => el.id !== id);
        setCartItems(remProducts);
    }
    const handleIncrement = (id) => {
        setCartItems(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            )
        );
    };

    const handleDecriment = (id) => {
        setCartItems(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        quantity: item.quantity > 1 ? item.quantity - 1 : 1
                    }
                    : item
            )
        );
    };

    const handleShippingAddressSelect = (address) => {
        setShippingAddress(address);
        setAddressShow(false);
    };

    const handleBillingAddressSelect = (address) => {
        setBillingAddress(address);
        setAddressShow(false);
    };

    const handleOrderNote = () => {
        setOrderNote(orderNoteValue);
        setShowNote(false);
    }


    const handleFinalSubmit = async () => {
       if (!isFormValid()) return;
        setFinalLoading(true);
        const requestData = {
            cartItems: cartItems,
            orderNote: orderNote,
            customer: customer,
            shippingAddress: shippingAddress,
            billingAddress: billingAddress,
            promoCode: '',
            delivery_charge: shipping_price,
            selectedShippingMethod:selectedShippingMethod
        }
        const resp = await GetOrders.createAdminOrder(requestData);

        if (resp && resp.status) {
            const reqData = {
                order_number: resp.order_number,
                cartItems: cartItems,
                customer: customer,
                promoCode: '',
                shipping_price:shipping_price || 0.00
            }
   
            const resp2 = await GetOrders.createCheckoutSession(reqData);
            if (resp2 && resp2.status) {
                setShowSuccess(true);
                setPaymentLink(resp2.url);
                setFinalLoading(false);
            } else {
                Alerts.alertMessage('Order created but payment link not created !', 'top-right', 'error');
                setFinalLoading(false);
            }

        } else {
            Alerts.alertMessage('Something went wrong !', 'top-right', 'error');
        }
    }
    const isFormValid = () => {
        return (
            cartItems && cartItems.length > 0 &&
            customer && Object.keys(customer).length > 0 &&
            shippingAddress && Object.keys(shippingAddress).length > 0 &&
            billingAddress && Object.keys(billingAddress).length > 0 &&  
            selectedShippingMethod && Object.keys(selectedShippingMethod).length > 0
        );
    };

    const handleCloseSuccess = () => {
        setShowSuccess(false);
        window.location.reload();
    }


    const handleSelectShippingMethod = (shipping_rate) => {
           setSelectedShippingMethod(shipping_rate);
           setShippingPrice(parseFloat(shipping_rate.shipping_rate.price));
    }
    return (
        <div className="innerPageWrapper">
            <div className='container-fluid'>
                <div className='page-title'>
                    <h2>
                        <FaShoppingBasket />
                        Create Order</h2>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-9'>
                        <Card>
                            <Card.Header>
                                Products
                            </Card.Header>
                            <Card.Body>
                                <div className='form-grpup search-product'>
                                    <input type='text' placeholder='Search products' className='form-control' value={query} onChange={(e) => setQuery(e.target.value)} />
                                    <div className='search-icon'>
                                        <FiSearch />
                                    </div>
                                    {loading && <div className="searchProduct"><Spinner animation="border" size="sm" variant="info"></Spinner></div>}
                                </div>


                                {query.length >= 2 && products.length > 0 && (
                                    <ul className={'suggestions'}>
                                        {
                                            products.map((item, index) => (
                                                <li key={index}>
                                                    {
                                                        <button onClick={() => getProduct(item)}>{item.title}</button>
                                                    }
                                                </li>
                                            ))
                                        }
                                    </ul>
                                )}

                                {
                                    cartItems && cartItems.length > 0 && <div className='selected-products'>
                                        <ul>
                                            {cartItems.map((item, i) => {

                                                return <li className='product-item'>
                                                    <div className='product-thumbnail'>
                                                        <img src={item.image} alt='' />
                                                    </div>
                                                    <div className='product-details'>
                                                        <h6>{item.title}</h6>
                                                        <button onClick={() => removeSelected(item.id)}>remove</button>
                                                    </div>
                                                    <div className='product-qunatity'>
                                                        <button type='button' onClick={() => handleDecriment(item.id)}>
                                                            <FiMinus />
                                                        </button>
                                                        <input type="number" value={item.quantity} className='no-arrows' />
                                                        <button type='button' onClick={() => handleIncrement(item.id)}><FiPlus /></button>

                                                    </div>
                                                    <div className='product-price'>
                                                        £ {(item.price * item.quantity).toFixed(2)}
                                                    </div>
                                                </li>
                                            })}
                                            <li></li>
                                        </ul>
                                    </div>
                                }

                            </Card.Body>
                        </Card>



                        <Card style={{ marginTop: 30 }}>
                            <Card.Header>
                                Payment
                            </Card.Header>
                            <Card.Body>
                                <div className='payment-details'>
                                    <ul>
                                        <li>
                                            <div>Subtotal</div>
                                            <div>£ {subtotal.toFixed(2)}</div>
                                        </li>
                                        <li>
                                            <div>Discount</div>
                                            <div>£ {discount.toFixed(2)}</div>
                                        </li>
                                        <li>
                                            <div>Shipping Or Delivery</div>
                                            <div>£ {shipping_price.toFixed(2)}</div>
                                        </li>
                                        <li>
                                            <div>Tax (20%)</div>
                                            <div>£ {tax.toFixed(2)}</div>
                                        </li>
                                        <li>
                                            <div>Total</div>
                                            <div>£ {total.toFixed(2)}</div>
                                        </li>
                                    </ul>

                                </div>
                            </Card.Body>
                        </Card>


                        <Card style={{ marginTop: 30 }}>
                            <Card.Header>
                                Shipping Method
                            </Card.Header>
                            <Card.Body>
                        

                                {   shippingAddress && billingAddress ?
                                    shipping_rates && shipping_rates.length > 0 ?
                                        shipping_rates.map((zone_rate) => {
                                            return <button
                                                key={zone_rate.id}
                                                className={`rateDetailItem`}
                                                onClick={() => handleSelectShippingMethod(zone_rate)}
                                            >
                                                <span className={`radioCheck ${zone_rate.id === selectedShippingMethod?.id ? 'activeRadioCheck' : ''}`}>
                                                    <span className={`radioCheckDot`}></span>
                                                </span>
                                                <div className={`rateContentWrapper`}>
                                                    <div className={`rateContent`}>
                                                        {parse(zone_rate.shipping_rate.shipping_rate_label.preview_label)}
                                                        <div className={`rateCondition`}>
                                                            {zone_rate.shipping_rate.shipping_rate_type === "price" && (
                                                                <>Price Range - (£{zone_rate.shipping_rate.min_price} - £{zone_rate.shipping_rate.max_price})</>
                                                            )}
                                                            {zone_rate.shipping_rate.shipping_rate_type === "weight" && (
                                                                <>Weight Range - ({zone_rate.shipping_rate.min_weight}kg - {zone_rate.shipping_rate.max_weight}kg)</>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="price-tag">
                                                        {parseFloat(zone_rate.shipping_rate.price) > 0 ? (
                                                            <div className="shipping-price">£{zone_rate.shipping_rate.price}</div>
                                                        ) : (
                                                            <span>Free</span>
                                                        )}
                                                    </div>
                                                </div>

                                            </button>
                                        })

                                        :<p className='rate-not-found'>Shipping not provided in this area.</p> 
                                        :<p className='rate-not-found'>Please select your shipping address !</p>
                                }
                            </Card.Body>
                        </Card>


                    </div>
                    <div className='col-md-3'>
                        <div className='order-sidebar'>
                            <Card>
                                <Card.Header className='address-header' style={{ marginBottom: 0 }}>
                                    <span>Order Note</span>
                                    <button onClick={() => setShowNote(true)}>
                                        <FaPencilAlt />
                                    </button>
                                </Card.Header>
                                <Card.Body>
                                    <p>{orderNote === '' ? 'No note found' : orderNote}</p>
                                    <ThemeModal show={isShowNote} handleHide={() => setShowNote(false)} title={orderNoteValue !== '' ? 'Update Note' : 'Add Note'} size='md'>
                                        <div className='mb-3'>
                                            <textarea className='form-control' value={orderNoteValue} onChange={(e) => setOrderNoteValue(e.target.value)} rows={5} />
                                        </div>
                                        <div className='text-center'>
                                            <button className='btn btn-default btn-sm' onClick={handleOrderNote}>{orderNoteValue !== '' ? 'Update Now' : 'Add Now'}</button>
                                        </div>

                                    </ThemeModal>
                                </Card.Body>
                            </Card>
                            <Card style={{ marginTop: 30 }}>
                                <Card.Header className='d-flex align-items-center justify-content-between'>
                                    Customer
                                    <AddNewUser setcQuery={setcQuery} />
                                </Card.Header>
                                <Card.Body>
                                    <div className='customer-details'>
                                        <div className='form-grpup search-product'>
                                            <input type='text' placeholder='Search customer' className='form-control' value={cQuery} onChange={(e) => setcQuery(e.target.value)} />
                                            <div className='search-icon'>
                                                <FiSearch />
                                            </div>
                                            {userLoading && <div className="searchProduct"><Spinner animation="border" size="sm" variant="info"></Spinner></div>}
                                        </div>
                                        {cQuery.length >= 2 && customers.length > 0 && (
                                            <ul className={'suggestions2'}>
                                                {
                                                    customers.map((customer, index) => (
                                                        <li key={index}>
                                                            {
                                                                <button onClick={() => handleCustomer(customer)}>{customer.email}</button>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        )}

                                        <p>{customer?.email}</p>
                                    </div>
                                </Card.Body>
                            </Card>

                            <Card style={{ marginTop: 30 }}>
                                <Card.Header className='shipping-address'>
                                    <span>Shipping & Billing Address</span>
                                </Card.Header>
                                <Card.Body >
                                    <div className='addressWrapper'>
                                        <div className='address-header'>
                                            <span>Shipping Address</span>
                                            {
                                                customer !== null && <button onClick={() => handleOpenAddress('shipping')}>
                                                    <FaPencilAlt />
                                                </button>
                                            }
                                        </div>
                                        <div className='address-box'>
                                            {
                                                customer === null ? <p style={{ fontSize: 12 }}>Address not added !</p> :
                                                    shippingAddress === null ? <p style={{ fontSize: 12 }}>Address not added !</p> : <>
                                                        {shippingAddress.address_line_1}, {shippingAddress.address_line_2}, {shippingAddress.city}, {shippingAddress.state}, {shippingAddress.country}, {shippingAddress.pin_code}
                                                    </>
                                            }

                                        </div>
                                    </div>
                                    <div className='addressWrapper' style={{ marginTop: 30 }}>
                                        <div className='address-header'>
                                            <span>Billing Address</span>
                                            {
                                                customer !== null && <button onClick={() => handleOpenAddress('billing')}>
                                                    <FaPencilAlt />
                                                </button>
                                            }
                                        </div>
                                        <div className='address-box'>
                                            {
                                                customer === null ? <p style={{ fontSize: 12 }}>Address not added !</p> :
                                                    billingAddress === null ? <p style={{ fontSize: 12 }}>Address not added !</p> : <>
                                                        {billingAddress.address_line_1}, {billingAddress.address_line_2}, {billingAddress.city}, {billingAddress.state}, {billingAddress.country}, {billingAddress.pin_code}
                                                    </>
                                            }

                                        </div>

                                        <ThemeModal show={isAddressShow} handleHide={handleCloseAddress} title="Add address" isHeader={true} isPd={false}>
                                            <div className='address-wrapper'>
                                                <div className='address-header'>
                                                    {!addNewAddress ? <p><strong>Existing User Address</strong></p> : <p style={{ fontSize: 14 }}>If you don't want to add new address</p>}
                                                    <button className={`btn ${!addNewAddress ? 'btn-default' : 'btn-danger'} btn-sm align-cetner`} onClick={() => setAddNewAddress(!addNewAddress)}>
                                                        {!addNewAddress ? <><FiPlus /> Add New</> : <><MdOutlineClose /> Close</>}
                                                    </button>
                                                </div>

                                                {
                                                    !addNewAddress ? <ul>
                                                        {

                                                            customerAddresses && customerAddresses.length > 0 && customerAddresses.map((address, i) => {

                                                                return <li key={address.id} className='address-items'>
                                                                    <label htmlFor={`addressCheck${i}`}>
                                                                        {
                                                                            addressType === 'shipping' ? <input
                                                                                type='radio'
                                                                                id={`addressCheck${i}`}
                                                                                name='address'
                                                                                value={address.id}
                                                                                checked={address.id === shippingAddress?.id}
                                                                                onClick={() => handleShippingAddressSelect(address)}
                                                                            /> : <input
                                                                                type='radio'
                                                                                id={`addressCheck${i}`}
                                                                                name='address'
                                                                                value={address.id}
                                                                                checked={address.id === billingAddress?.id}
                                                                                onClick={() => handleBillingAddressSelect(address)}
                                                                            />
                                                                        }

                                                                        <span>
                                                                            {address.address_line_1}, {address.address_line_2}, {address.city}, {address.state}, {address.country}, {address.pin_code}
                                                                        </span>
                                                                    </label>
                                                                </li>
                                                            })
                                                        }

                                                    </ul> : <AddAddressCreateOrder customer={customer} setAddNewAddress={setAddNewAddress} setCustomerAddresses={setCustomerAddresses} />
                                                }
                                            </div>
                                        </ThemeModal>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </div>
                <div className='text-center mt-3'>
                    <button className='btn btn-primary' onClick={handleFinalSubmit} disabled={!isFormValid() || finalLoading}> {finalLoading ? "Processing..." : "Create Order"}</button>
                </div>

                <ThemeModal show={isShowSuccess} handleHide={() => setShowSuccess(false)} title="" isHeader={false} centered={true}>
                    <div className='success-box'>
                        <div className='success-icon'>
                            <img src='/images/correct.png' alt='' />
                        </div>

                        <h3>Order created successfully !</h3>
                        <p>Order Pyament link - <a href={paymentLink} target='_black'>Click here</a></p>
                    </div>
                    <div className='success-actions'>
                        <Link to={'/app/orders/view'} className='btn btn-info btn-sm'>View Orders</Link>
                        <button className='btn btn-danger btn-sm' onClick={handleCloseSuccess}>Close</button>
                    </div>
                </ThemeModal>
            </div>
        </div>
    )
}

export default CreateOrder;